import React, { FC, useMemo } from "react";
import styles from "../styles.module.less";
import { useTranslation } from "react-i18next";
import { getImgSrc } from "@/utils";
import { Button } from "antd";
import { useMediaSize } from "@/hooks/useMediaSize";

/**
 * 主体类型容器
 */
const PrincipalTypeContainer: FC<{
  imgSrc: string;
  principalType: string;
  principalTypeName: string;
  principalTypeDescription: string;
  toPersonalAuthentication: Function;
  toEnterpriseAuthentication: Function;
}> = ({
  imgSrc,
  principalType,
  principalTypeName,
  principalTypeDescription,
  toPersonalAuthentication,
  toEnterpriseAuthentication,
}) => {
  const { t } = useTranslation();

  const { isPhoneMedia } = useMediaSize();

  const action = useMemo(
    () =>
      isPhoneMedia
        ? {
            onClick: () =>
              principalType === "P"
                ? toPersonalAuthentication()
                : toEnterpriseAuthentication(),
          }
        : {},
    [
      isPhoneMedia,
      principalType,
      toEnterpriseAuthentication,
      toPersonalAuthentication,
    ]
  );

  return (
    <div className={styles.principalTypeList} {...action}>
      <div className={styles.principalTypeImgContainer}>
        <img
          className={styles.principalTypeImg}
          src={getImgSrc(imgSrc)}
          alt=""
        />
      </div>
      <div className={styles.principalTypeContent}>
        <span className={styles.principalTypeTitle}>
          {t(principalTypeName)}
        </span>
        <span className={styles.principalTypeDescription}>
          {t(principalTypeDescription)}
        </span>
      </div>
      <div className={styles.opsButtonContainer}>
        <Button
          type="primary"
          onClick={() =>
            principalType === "P"
              ? toPersonalAuthentication()
              : toEnterpriseAuthentication()
          }
        >
          {t("user.getAuthenticated")}
        </Button>
      </div>
    </div>
  );
};

/**
 * 主体未认证
 */
export const NoPrincipal: FC<{
  toPersonalAuthentication: Function;
  toEnterpriseAuthentication: Function;
}> = ({ toPersonalAuthentication, toEnterpriseAuthentication }) => {
  return (
    <div className={styles.authenticationWrapper}>
      <PrincipalTypeContainer
        imgSrc="/personalAuthentication.png"
        principalType="P"
        principalTypeName="user.personalAuthentication"
        principalTypeDescription="user.personalAuthenticationDescription"
        toPersonalAuthentication={toPersonalAuthentication}
        toEnterpriseAuthentication={toEnterpriseAuthentication}
      />
      <PrincipalTypeContainer
        imgSrc="/enterpriseAuthentication.png"
        principalType="E"
        principalTypeName="user.enterpriseAuthentication"
        principalTypeDescription="user.enterpriseAuthenticationDescription"
        toPersonalAuthentication={toPersonalAuthentication}
        toEnterpriseAuthentication={toEnterpriseAuthentication}
      />
    </div>
  );
};
